import React, { Component } from 'react'
import _ from 'lodash'
import { axios } from '~/axios'
import { Helmet } from 'react-helmet'

import Article from './article'
import StickyFooter from '~/components/StickyFooter'
import SharingFooter from './sharingFooter'
import userLanguageSelector from '~/tools/localization/userLanguageSelector'

import './style.scss'
import { trackPageview } from '~/tools/analytics/googleAnalytics';

class ArticleLoader extends Component {

  state = {
    currentArticleId: _.get(this.props.data, "contentData[0].id", null),
    infiniteScroll: _.get(this.props.data, "metadataMap.infiniteScroll") === "true",
    articles: {}
  };

  articlesToFetch = _.get(
    this.props.data,
    "contentData[0].contentDetails.relatedArticleIds",
    []
  );

  articlePositions = [];

  loading = false;


  componentDidMount() {
    this.addArticle(this.props.data.contentData[0]);
  }

  loadNextArticle = () => {
    if (this.loading) return;
    if (_.isEmpty(this.state.articles)) return;

    this.loading = true;
    const nextArticleId = this.articlesToFetch.pop();
    axios
      .get("/content/article", {
        params: {
          id: nextArticleId,
          languageCode: userLanguageSelector()
        }
      })
      .then(res => {
        trackPageview(
          window.location.origin + res.data.permalink,
          res.data.gist.title
        );
        this.addArticle(res.data);
      });
  };

  updateArticlePositions = (articleId, yPos) => {
    const newArticlePos = {
      id: articleId,
      yPos: yPos
    };
    this.articlePositions.push(newArticlePos);
  };

  addArticle(article) {
    axios.get(article.streamingInfo.articleAssets.url).then(response => {
      article.content = response.data;
      this.loading = false;
      this.setState(state => _.set(state, `articles.${article.id}`, article));
    });
  }

  renderArticles() {
    const adTag = _.get(this.props, "data.metadataMap.adTag");
    return _.map(this.state.articles, article => (
      <Article
        key={article.id}
        article={article}
        ad={adTag}
        updatePosition={this.updateArticlePositions}
      />
    ));
  }

  get titleToShare() {
    const articleToShare =
      this.state.articles[this.state.currentArticleId] ||
      _.get(this.props, "data.contentData[0]");

    return _.get(articleToShare, "gist.title");
  }

  updateCurrentArticle = () => {
    const mostVisibleArticle = this.getMostVisibleArticle();

    if (
      mostVisibleArticle &&
      this.state.currentArticleId !== mostVisibleArticle.id
    ) {
      this.setArticleUrl(mostVisibleArticle);
      this.setCurrentArticle(mostVisibleArticle);
    }
  };

  getMostVisibleArticle() {
    const scrollOffset = window.pageYOffset;
    const currentViewPort = {
      start: scrollOffset,
      end: Math.ceil(scrollOffset + 1) + window.innerHeight
    };

    let mostVisibleArticle;
    _.each(this.articlePositions, articlePos => {
      if (!this.isArticleInView(articlePos.yPos, currentViewPort)) return;

      let articleView = {
        articlePos: articlePos,
        amount: this.getAmountOfVisibleArticle(articlePos.yPos, currentViewPort)
      };

      if (!mostVisibleArticle || articleView.amount > mostVisibleArticle.amount)
        mostVisibleArticle = articleView;
    });

    return mostVisibleArticle
      ? this.state.articles[mostVisibleArticle.articlePos.id]
      : null;
  }

  setArticleUrl(article) {
    const { title = "", permalink = window.location.href } = article.gist;

    window.history.replaceState({}, title, permalink);
  }

  setCurrentArticle(article) {
    this.setState({
      currentArticleId: article.id
    });
  }

  getAmountOfVisibleArticle(articleYPos, currentViewPort) {
    const positions = _.sortBy([
      articleYPos.start,
      articleYPos.end,
      currentViewPort.start,
      currentViewPort.end
    ]);
    return positions[2] - positions[1];
  }

  isArticleInView(articleYPos, currentViewPort) {
    return (
      articleYPos.start <= currentViewPort.end &&
      currentViewPort.start <= articleYPos.end
    );
  }

  get helmet() {
    const { gist = {}, seo = {} } = this.props.data.contentData[0];

    return (
      <Helmet>
        <title>{`${seo.title || gist.title} | ${window.settings.site}`}</title>
        <meta
          name="description"
          content={seo.description || gist.description}
        />
        {seo.keywords && (
          <meta name="keywords" content={seo.keywords.join(",")} />
        )}
        <meta property="og:type" content="article" />
        <meta property="og:title" content={seo.title || gist.title} />
        <meta
          property="og:description"
          content={seo.description || gist.description}
        />
        <meta
          property="og:image"
          content={
            gist.landscapeImageUrl ||
            _.get(window.settings, "images.placeholderCover")
          }
        />
      </Helmet>
    );
  }

  shouldShowStickyFooter() {
    return (
      !_.isEmpty(this.state.articles) &&
      !window.sessionStorage.getItem("isApp") &&
      _.get(this.props, "data.metadataMap.infiniteScroll", "") === "true"
    );
  }

  render() {
    return (
      <div className="infinite-article-container">
        {this.helmet}
        {this.renderArticles()}

        {this.shouldShowStickyFooter() && (
          <StickyFooter
            onScroll={this.updateCurrentArticle}
            onBottom={this.state.infiniteScroll && this.loadNextArticle}
          >
            <SharingFooter
              path={window.location.href}
              title={this.titleToShare}
            />
          </StickyFooter>
        )}
      </div>
    );
  }
}

export default ArticleLoader;
